import {Stack} from "@mui/material"
import {FC} from "react"
import {Outlet, useOutletContext} from "react-router-dom"
import {ProfileInfo} from "../../components"
// import {useTranslation} from "react-i18next"
import NavigationTabs from "../../components/molecules/NavigationTabs/NavigationTabs"
import {accountEndpoints} from "../../services"
import {useQuery, UseQueryResult} from "@tanstack/react-query"
import {useConfigProvider} from "../../config"
import {decodeToken} from "react-jwt"
import {Contact, Token} from "../../types"
import {useSessionStorage} from "usehooks-ts"
import {StorageData} from "../../hooks/useStorage"
import {useTranslation} from "react-i18next"
import {CrmAccount} from "../../types/CrmAccount"

interface Context {
  profileQuery: UseQueryResult<Contact, Error>
}
const Profile: FC = () => {
  const {token} = useConfigProvider()
  const {getProfileInfo, getInternalUser} = accountEndpoints()
  const decoded = decodeToken<Token>(token)
  const accountNumber = decoded?.companyId || ""

  const email = decoded?.email
  const [completed] = useSessionStorage<boolean | undefined>(
    StorageData.completedPreferences,
    undefined,
  )
  const {t} = useTranslation()
  const getProfileInfoQuery = useQuery({
    queryKey: ["profileInfo", email],
    queryFn: () => getProfileInfo(email!!),
    enabled: !!email && accountNumber !== CrmAccount.Internal,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    gcTime: 1000 * 60 * 30, // 30 minutes
  })

  const getInternalUserQuery = useQuery({
    queryKey: ["internalUser", email],
    queryFn: () => getInternalUser(email!!),
    enabled: !!email && accountNumber === CrmAccount.Internal,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    gcTime: 1000 * 60 * 30, // 30 minutes
  })

  const completedPreferences =
    !!decoded?.completedPreferences || !!completed || false

  return (
    <Stack
      component="main"
      id="profile"
      aria-label="Profile"
      direction="row"
      height="100%"
      bgcolor="#fbfbfb"
    >
      <ProfileInfo
        getProfileInfoQuery={getProfileInfoQuery}
        getInternalUserQuery={getInternalUserQuery}
      />
      <Stack
        component="section"
        direction="column"
        flexGrow={1}
        width="auto"
        height="100%"
        marginLeft="236px"
      >
        <NavigationTabs
          tabs={[
            {
              title: t("Details"),
              link: "/profile",
            },
            {
              title: t("Preferences"),
              link: "/profile/preferences",
              warningIcon: !completedPreferences,
            },
          ]}
        />
        <Outlet
          context={
            {
              profileQuery: getProfileInfoQuery,
            } satisfies Context
          }
        />
      </Stack>
    </Stack>
  )
}

export default Profile

export function useProfileContext() {
  return useOutletContext<Context>()
}
